<template>
  <div class="formNickname">
    <input
      type="text"
      name="nickname"
      class="formNickname__input"
      :class="{ 'formNickname__input--error': errors.has('nickname') }"
      placeholder="ニックネーム"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @change="$emit('input', $event.target.value)"
      v-validate="'required'"
    />
    <div v-show="errors.first('nickname')" class="formNickname__error">
      {{ errors.first('nickname') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'formNickname',
  props: {
    value: {
      type: String,
      default: '',
    }
  },
}
</script>

<style lang="scss" scoped>
.formNickname {
  &__input {
    appearance: none;
    width: 100%;
    line-height: 20px;
    padding: 9px 0 8px;
    height: 40px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #DCDFE2;
    outline: none;
    transition: 0.2s;
    &:focus {
      border-color: #1b1761;
    }
    &--error {
      background-color: #fff4f5;
    }
    &::placeholder {
      color: #DCDFE2;
    }
  }
  &__error {
    color: #FF7497;
    font-size: 13px;
    margin: 0;
    margin-top: 6px;
    line-height: 20px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/formNickname.vue